import React, { useEffect, useState } from "react";
import styled from "styled-components";
import api from "../api";

/* Mapeamento esquema_id → formação legível */
const ESQUEMAS = {
  1: "4-4-2",
  2: "4-3-3",
  3: "3-5-2",
  4: "5-3-2",
  5: "4-5-1",
  6: "3-4-3",
  7: "5-4-1",
  8: "4-2-4",
  9: "4-3-2-1",
  10: "4-2-3-1",
  11: "3-4-2-1",
  12: "5-2-3",
};

/* ===== Overlay & Container ===== */
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.78);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 12px;
  overflow-y: auto;
`;

const Container = styled.div`
  background: #1a1a2e;
  border-radius: 14px;
  width: 100%;
  max-width: 480px;
  max-height: 92vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 16px 10px;
  background: #16213e;
  border-radius: 14px 14px 0 0;
  flex-shrink: 0;
`;

const Title = styled.h2`
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CloseBtn = styled.button`
  background: none;
  border: none;
  color: #aaa;
  font-size: 20px;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
  margin-left: 8px;
  &:hover { color: #fff; }
`;

const TotalPtsBar = styled.div`
  background: #16213e;
  text-align: center;
  padding: 4px 0 6px;
  font-size: 15px;
  font-weight: 700;
  color: #f0db4f;
  flex-shrink: 0;
`;

const FormacaoBar = styled.div`
  background: #16213e;
  text-align: center;
  padding: 0 0 8px;
  font-size: 11px;
  color: #6fc86f;
  letter-spacing: 1.5px;
  font-weight: 600;
  flex-shrink: 0;
`;

/* ===== Campo ===== */
const Campo = styled.div`
  position: relative;
  background: linear-gradient(180deg, #1e6b1e 0%, #27933a 40%, #2aad44 50%, #27933a 60%, #1e6b1e 100%);
  margin: 0 10px 0;
  border-radius: 8px;
  border: 2px solid rgba(255, 255, 255, 0.55);
  padding: 8px 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
`;

const CenterLine = styled.div`
  position: absolute;
  left: 6%;
  right: 6%;
  top: 50%;
  transform: translateY(-50%);
  height: 1px;
  background: rgba(255, 255, 255, 0.3);
  pointer-events: none;
`;

const CenterCircle = styled.div`
  position: absolute;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.3);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
`;

const Linha = styled.div`
  display: flex;
  justify-content: center;
  gap: 4px;
  flex-wrap: wrap;
  position: relative;
  z-index: 1;
  min-height: 72px;
  align-items: center;
  padding: 2px 0;
`;

const LinhaLabel = styled.div`
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 8px;
  color: rgba(255,255,255,0.3);
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-weight: 700;
  pointer-events: none;
  user-select: none;
`;

/* ===== Banco ===== */
const BancoWrapper = styled.div`
  margin: 6px 10px 10px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 8px 10px;
`;

const BancoLabel = styled.div`
  font-size: 10px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 8px;
  text-align: center;
`;

const BancoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 6px;
`;

const TecnicoCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 8px;
  border-right: 1px solid rgba(255, 255, 255, 0.18);
  margin-top: 4px;
`;

const TecnicoLabel = styled.div`
  font-size: 9px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 3px;
`;

const ReservasRow = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

/* ===== AtletaCard ===== */
const AtletaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${props => props.small ? "46px" : "54px"};
  position: relative;
  opacity: ${props => props.naoJogou ? 0.45 : 1};
  transition: opacity 0.2s;
`;

const BadgeIcon = styled.span`
  font-size: 11px;
  position: absolute;
  top: -4px;
  right: -3px;
  z-index: 2;
  line-height: 1;
  filter: drop-shadow(0 0 2px rgba(0,0,0,0.6));
`;

const SubBadge = styled.span`
  font-size: 13px;
  font-weight: 900;
  position: absolute;
  bottom: 20px;
  right: -6px;
  z-index: 3;
  line-height: 1;
  color: ${props => props.entrou ? "#4cff72" : "#ff4c4c"};
  text-shadow: 0 0 4px rgba(0,0,0,0.8);
  pointer-events: none;
`;

const FotoCircle = styled.div`
  width: ${props => props.small ? "34px" : "40px"};
  height: ${props => props.small ? "34px" : "40px"};
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  border: 2px solid ${
    props => props.capitao
      ? "#f0db4f"
      : props.naoJogou
        ? "rgba(180,60,60,0.6)"
        : "rgba(255,255,255,0.45)"
  };
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${props => props.small ? "14px" : "18px"};
  flex-shrink: 0;
`;

const Foto = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const AtletaNome = styled.div`
  font-size: 9px;
  color: #e8e8e8;
  text-align: center;
  margin-top: 3px;
  max-width: 54px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.2;
`;

const AtletaPts = styled.div`
  font-size: 10px;
  font-weight: 700;
  color: ${props => props.positivo ? "#6fe86f" : "#aaa"};
  text-align: center;
  line-height: 1.1;
`;

const CapTag = styled.div`
  font-size: 8px;
  color: #f0db4f;
  text-align: center;
  line-height: 1;
`;

/* ===== CardAtleta ===== */
const CardAtleta = ({ atleta, ehCapitao, isTecnico, ehReservaLuxo, foiSubstituido, entouComoReserva }) => {
  const naoJogou = atleta.entrou_em_campo === false;
  const pontos = ehCapitao ? atleta.pontos_num * 1.5 : atleta.pontos_num;
  const nome = atleta.apelido_abreviado || atleta.apelido || atleta.nome || "?";
  const [fotoError, setFotoError] = useState(false);

  return (
    <AtletaWrapper small={isTecnico} naoJogou={naoJogou}>
      {ehCapitao && <BadgeIcon>⭐</BadgeIcon>}
      {ehReservaLuxo && <BadgeIcon style={{ right: "auto", left: "-3px" }}>💎</BadgeIcon>}
      {foiSubstituido && <SubBadge entrou={false}>⬇</SubBadge>}
      {entouComoReserva && <SubBadge entrou={true}>⬆</SubBadge>}
      <FotoCircle capitao={ehCapitao} naoJogou={naoJogou} small={isTecnico}>
        {atleta.foto && !fotoError ? (
          <Foto src={atleta.foto} alt={nome} onError={() => setFotoError(true)} />
        ) : (
          <span>⚽</span>
        )}
      </FotoCircle>
      <AtletaNome title={nome}>{nome}</AtletaNome>
      <AtletaPts positivo={pontos > 0}>
        {pontos.toFixed(1)}
      </AtletaPts>
      {ehCapitao && <CapTag>×1.5</CapTag>}
    </AtletaWrapper>
  );
};

/* ===== CampoFutebol ===== */
const CampoFutebol = ({ idTimeRodada, nomeTime, onClose }) => {
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    api.get(`liga/detalheTimeRodada/${idTimeRodada}`)
      .then(res => { setDados(res.data); setLoading(false); })
      .catch(() => { setErro("Erro ao carregar escalação do time."); setLoading(false); });
  }, [idTimeRodada]);

  const renderConteudo = () => {
    if (loading) {
      return (
        <div style={{ padding: "40px 16px", textAlign: "center", color: "#aaa" }}>
          ⏳ Carregando escalação...
        </div>
      );
    }
    if (erro || !dados) {
      return (
        <div style={{ padding: "40px 16px", textAlign: "center", color: "#e74c3c" }}>
          {erro || "Sem dados disponíveis."}
        </div>
      );
    }

    const { atletas = [], reservas = [], capitao_id, reserva_luxo_id, esquema_id } = dados;

    const goleiros  = atletas.filter(a => a.posicao_id === 1);
    const laterais  = atletas.filter(a => a.posicao_id === 2);
    const zagueiros = atletas.filter(a => a.posicao_id === 3);
    const meias     = atletas.filter(a => a.posicao_id === 4);
    const atacantes = atletas.filter(a => a.posicao_id === 5);
    const tecnico   = atletas.find(a => a.posicao_id === 6);

    // Defesa unificada para o campo: laterais + zagueiros
    const defesa = [...laterais, ...zagueiros];

    const formacao = ESQUEMAS[esquema_id] || null;

    const totalPts = atletas.reduce((acc, a) =>
      acc + (a.atleta_id === capitao_id ? a.pontos_num * 1.5 : a.pontos_num), 0);

    const reservasList = reservas || [];

    // IDs dos titulares que NÃO jogaram (foram substituídos ou ficaram sem jogar)
    const titularesNaoJogaramIds = new Set(
      atletas
        .filter(a => a.posicao_id !== 6 && a.entrou_em_campo === false)
        .map(a => a.atleta_id)
    );
    // Reservas que efetivamente entraram em campo
    const reservasQueEntraramIds = new Set(
      reservasList
        .filter(a => a.entrou_em_campo === true)
        .map(a => a.atleta_id)
    );

    return (
      <>
        <TotalPtsBar>{totalPts.toFixed(2)} pts</TotalPtsBar>
        {formacao && <FormacaoBar>▣ {formacao}</FormacaoBar>}

        <Campo>
          <CenterLine />
          <CenterCircle />
          {atacantes.length > 0 && (
            <Linha>
              <LinhaLabel>ATA</LinhaLabel>
              {atacantes.map(a => (
                <CardAtleta key={a.atleta_id} atleta={a} ehCapitao={a.atleta_id === capitao_id}
                  foiSubstituido={titularesNaoJogaramIds.has(a.atleta_id)} />
              ))}
            </Linha>
          )}
          {meias.length > 0 && (
            <Linha>
              <LinhaLabel>MEI</LinhaLabel>
              {meias.map(a => (
                <CardAtleta key={a.atleta_id} atleta={a} ehCapitao={a.atleta_id === capitao_id}
                  foiSubstituido={titularesNaoJogaramIds.has(a.atleta_id)} />
              ))}
            </Linha>
          )}
          {defesa.length > 0 && (
            <Linha>
              <LinhaLabel>DEF</LinhaLabel>
              {defesa.map(a => (
                <CardAtleta key={a.atleta_id} atleta={a} ehCapitao={a.atleta_id === capitao_id}
                  foiSubstituido={titularesNaoJogaramIds.has(a.atleta_id)} />
              ))}
            </Linha>
          )}
          {goleiros.length > 0 && (
            <Linha>
              <LinhaLabel>GOL</LinhaLabel>
              {goleiros.map(a => (
                <CardAtleta key={a.atleta_id} atleta={a} ehCapitao={a.atleta_id === capitao_id}
                  foiSubstituido={titularesNaoJogaramIds.has(a.atleta_id)} />
              ))}
            </Linha>
          )}
        </Campo>

        <BancoWrapper>
          <BancoLabel>Banco de reservas</BancoLabel>
          <BancoRow>
            {tecnico && (
              <TecnicoCol>
                <CardAtleta atleta={tecnico} isTecnico />
                <TecnicoLabel>Técnico</TecnicoLabel>
              </TecnicoCol>
            )}
            <ReservasRow>
              {reservasList.map(a => (
                <CardAtleta
                  key={a.atleta_id}
                  atleta={a}
                  ehReservaLuxo={a.atleta_id === reserva_luxo_id}
                  entouComoReserva={reservasQueEntraramIds.has(a.atleta_id)}
                />
              ))}
            </ReservasRow>
          </BancoRow>
        </BancoWrapper>
      </>
    );
  };

  return (
    <Overlay onClick={onClose}>
      <Container onClick={e => e.stopPropagation()}>
        <Header>
          <Title>⚽ {nomeTime}</Title>
          <CloseBtn onClick={onClose}>✕</CloseBtn>
        </Header>
        {renderConteudo()}
      </Container>
    </Overlay>
  );
};

export default CampoFutebol;
